









































































































































































































import Vue from "vue";
import { FMessageBox, FForm, FFormStep, FTextField, FTextareaField, FIcon, FLoader } from "@fkui/vue";
import { ValidationService, isString } from "@fkui/logic";
import { SkickaEpostRestVO } from "skickaepost-rest-api/dist/typescript-axios/api";
import { SkickaEpostRESTService } from "@/services";
import { ROUTES } from "@/router";
import ReceiptData from "@/types/ReceiptData";
import { SKICKA_EPOST_MOTTAGARE_BASE, SKICKA_EPOST_MOTTAGARE_DEFAULT_SERVICE_PARAM, SERVICE_BASE } from "@/constants";

export default Vue.extend({
    name: "Application",
    components: {
        FMessageBox,
        FForm,
        FFormStep,
        FTextField,
        FTextareaField,
        FIcon,
        FLoader,
    },
    data() {
        return {
            service: undefined as string | undefined,
            description: undefined,
            aid: undefined,
            name: undefined,
            phone: undefined,
            email: undefined,
            showLoader: false,
            inFlight: false,
        };
    },
    computed: {
        message(): string {
            return `${this.$t("anmtillganglighetsbrist.etikett.vilkentjanst")}\n${this.service || "-"}\n\n
            ${this.$t("anmtillganglighetsbrist.etikett.meddelande")}\n${this.description || "-"}\n\n
            ${this.$t("anmtillganglighetsbrist.etikett.vilkethjalpmedel")}\n${this.aid || "-"}`;
        },
        requirePhoneOrEmail(): boolean {
            return !!this.name && !this.phone && !this.email;
        },
        requireName(): boolean {
            return !!this.phone || !!this.email;
        },
        serviceParam(): string {
            const serviceParamQuery = this.$route.query.service;
            return isString(serviceParamQuery)
                ? (serviceParamQuery as string)
                : SKICKA_EPOST_MOTTAGARE_DEFAULT_SERVICE_PARAM;
        },
        showHelpTextPhone(): boolean {
            return (!this.phone && !this.name) || (this.email && this.name) ? true : false;
        },
        showHelpTextEmail(): boolean {
            return (!this.email && !this.name) || (this.phone && this.name) ? true : false;
        },
    },
    watch: {
        name: "validateUserInfo",
        phone: "validateUserInfo",
        email: "validateUserInfo",
    },
    created(): void {
        window.onbeforeunload = () => true;
        this.service = this.$t(`${SERVICE_BASE}${this.serviceParam}`, "");
    },
    methods: {
        async onSubmit(): Promise<void> {
            if (this.inFlight) {
                return;
            }
            this.inFlight = true;
            this.showLoader = true;
            const data: SkickaEpostRestVO = {
                meddelandeSomSkickas: this.message,
                mottagare: `${SKICKA_EPOST_MOTTAGARE_BASE}${this.serviceParam}`,
                //EUD-974: update to correct no reply address
                avsandare: this.email || this.$t("anmtillganglighetsbrist.avsandare.generell"),
                namn: this.name,
                telefon: this.phone,
            };
            try {
                await SkickaEpostRESTService.skickaEpost(data);
                window.onbeforeunload = () => undefined;
                this.$router.push({
                    name: ROUTES.RECEIPT.name,
                    params: {
                        ...new ReceiptData({ name: this.name, phone: this.phone, email: this.email }),
                        requested: "true",
                    },
                });
            } catch (err) {
                this.inFlight = false;
                throw new Error(err);
            }
        },
        async validateUserInfo(): Promise<void> {
            await this.$nextTick();
            ValidationService.validateAllElements("userInfo");
        },
        asVoluntary(labelKey: string): string {
            return `${this.$t(labelKey)} ${this.$t("SBRV.etikett.ejobligatoriskuppgift")}`;
        },
    },
});
